namespace SorAraBul.Definitions {
    export interface CountriesRow {
        Id?: number;
        Name?: string;
        GlobalName?: string;
        CountryCode?: string;
    }

    export namespace CountriesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Definitions.Countries';
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = '*';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            GlobalName = "GlobalName",
            CountryCode = "CountryCode"
        }
    }
}
